import React from 'react';
import PropTypes from 'prop-types';

import SubscriptionIdentitySelect from './SubscriptionIdentitySelect';
import withModal from '../../../../../../../../../components/global/modal/withModal';

export const SUBSCRIPTION_IDENTITY_SELECT_MODAL =
  'modal/SUBSCRIPTION_IDENTITY_SELECT';

const propTypes = {
  actionProps: PropTypes.shape({
    onIdentitySelect: PropTypes.func.isRequired,
  }),
  onRequestClose: PropTypes.func,
};

const SubscriptionIdentitySelectModal = ({
  actionProps,
  onRequestClose,
  ...props
}) => {
  const { onIdentitySelect, albumFolderId, albumId } = actionProps;
  return (
    <SubscriptionIdentitySelect
      onIdentitySelect={onIdentitySelect}
      albumFolderId={albumFolderId}
      albumId={albumId}
      onClose={onRequestClose}
      {...props}
    />
  );
};

SubscriptionIdentitySelectModal.propTypes = propTypes;

export default withModal(SubscriptionIdentitySelectModal, {
  name: SUBSCRIPTION_IDENTITY_SELECT_MODAL,
  size: 'sm',
  type: 'full',
});
